// Carousels
var Flickity = require('flickity');

const carousels = document.querySelectorAll('.js-carousel');

carousels.forEach((elem) => {
  const flickity = elem.querySelector('.carousel-images')
  const caption = elem.querySelector('.carousel-caption');
  const figcaptions = flickity.querySelectorAll('figcaption');

  elem.querySelectorAll('figcaption').forEach((figcaption) => {
    figcaption.classList.add('visually-hidden');
  })

  new Flickity(flickity, {
    pageDots: false,
    wrapAround: true,
    adaptiveHeight: true,
    cellAlign: 'left',
    arrowShape: 'M 100,48 7.3,48 39.9,14.2 37.1,11.5 0,50 37.1,88.5 39.9,85.8 7.3,51.9 100,51.9 Z',
    on: {
      select: function (index) {
        caption.innerHTML = figcaptions[index].innerHTML;
      }
    }
  });
})
